/**
 * @generated SignedSource<<b9ef3368007031d894e675d8c3d5c638>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommentReplyFragment$data = {
  readonly id: string;
  readonly topic: {
    readonly forum: {
      readonly owner: {
        readonly id: string;
      };
    };
  };
  readonly viewerCanReply: boolean;
  readonly " $fragmentType": "CommentReplyFragment";
};
export type CommentReplyFragment$key = {
  readonly " $data"?: CommentReplyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentReplyFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommentReplyFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": "viewerCanReply",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_COMMENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_COMMENT\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topic",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Forum",
          "kind": "LinkedField",
          "name": "forum",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Comment",
  "abstractKey": null
};
})();

(node as any).hash = "1e12ad785f25d34b9aeacea5e05aa631";

export default node;
